export const intlStringToNumber = (str: string): number => Number(str.replace(',', '.'));
